function createError(code) {
  const error = new Error(code);
  error.code = code;
  return error;
}
export {
  createError as default
};
